import { useState } from "react";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import { IoCloudUploadOutline } from "react-icons/io5";
import { toast } from "react-hot-toast";
import Classes from "./styles/style.module.css";
import { baseURL } from "../../assets/constants/baseUrl";
import errorHandler from "../../assets/utils/ErrorHandler";

const FormFileUploader = ({
  file: uploadedFile,
  setFile: setUploadedFile,
  formId,
  title,
  subtitle,
  desc,
  req,
  type,
}) => {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  const getAcceptTypes = () => {
    switch (type) {
      case "image":
        return { "image/*": [] };
      case "video":
        return { "video/*": [] };
      case "audio":
        return { "audio/*": [] };
      case "pdf":
        return { "application/pdf": [] };
      case "doc":
        return {
          "application/msword": [],
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
            [],
        };
      case "excel":
        return {
          "application/vnd.ms-excel": [],
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
            [],
        };
      default:
        return {};
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => handleFileUpload(acceptedFiles),
    maxFiles: 1,
    // onDropRejected: () => toast.error("لطفاً فقط یک فایل بارگذاری کنید."),
    accept: getAcceptTypes(),
  });

  const getFileTypeLabel = () => {
    switch (type) {
      case "image":
        return "تصویر";
      case "video":
        return "ویدیو";
      case "audio":
        return "صوت";
      case "pdf":
        return "PDF";
      case "doc":
        return "Word";
      case "excel":
        return "Excel";
      default:
        return "مجاز";
    }
  };

  const handleFileUpload = async (files) => {
    const validFiles = files.filter((file) => {
      if (!file.type) return false;
      switch (type) {
        case "image":
          return file.type.startsWith("image/");
        case "video":
          return file.type.startsWith("video/");
        case "audio":
          return file.type.startsWith("audio/");
        case "pdf":
          return file.type === "application/pdf";
        case "doc":
          return (
            file.type === "application/msword" ||
            file.type ===
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          );
        case "excel":
          return (
            file.type === "application/vnd.ms-excel" ||
            file.type ===
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          );
        default:
          return true;
      }
    });

    if (validFiles.length === 0) {
      toast.error("نوع فایل انتخاب‌شده مجاز نیست");
      return;
    }

    const formData = new FormData();
    files.forEach((file) => {
      formData.append("file", file);
    });
    try {
      setLoading(true);
      const response = await axios.post(
        `${baseURL}file/upload/user?formId=${formId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("UserToken")}`,
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProgress(percentCompleted);
          },
        }
      );

      setUploadedFile(response.data.file);
      toast.success("فایل با موفقیت بارگذاری شد.");
    } catch (error) {
      errorHandler(error);
      setProgress(0);
    } finally {
      setLoading(false);
      setProgress(0);
    }
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    setUploadedFile(null);
  };

  return (
    <div className={Classes.uploaderContainer}>
      <div>
        <p className={Classes.formTitle}>
          {title} <span className="text-danger" style={{display:"inline"}}>{req ? "*" : null}</span>
        </p>
      </div>
      <div className="px-2">
        {subtitle && <p className={Classes.subTitle}>{subtitle}</p>}
        <div {...getRootProps()} className={Classes.uploader}>
          <input {...getInputProps()} />
          {uploadedFile ? (
            <div className={Classes.filePreviewWrapper}>
              {uploadedFile.match(/\.(jpg|jpeg|png|gif|bmp|webp)$/i) ? (
                <img
                  src={uploadedFile}
                  alt="Uploaded preview"
                  className={Classes.imagePreview}
                />
              ) : (
                <p className={Classes.fileName}>
                  {uploadedFile.replace(/^http.*\/file\/get\//, "")}
                </p>
              )}
              <button
                type="button"
                className={Classes.removeButton}
                onClick={handleRemove}
              >
                حذف
              </button>
            </div>
          ) : (
            <>
              <IoCloudUploadOutline size={60} />
              <p>
                {loading
                  ? `در حال بارگذاری: ${progress}%`
                  : `یک فایل ${getFileTypeLabel()} را اینجا بکشید یا کلیک کنید`}
              </p>
            </>
          )}
        </div>
        {desc && <p className={Classes.desc}>{desc}</p>}
      </div>
    </div>
  );
};

export default FormFileUploader;
